const data = [
    { id: 1, exam_with_year: 'Data 1', exam: 'Data 2',code: 'Data 3', batch: 'Data 4',semester: 'Data 5', examtype: 'Data 6',
    any: 'Data 7', month: 'Data 8',year: 'Data 9', Type: 'Data 10'},
    { id: 2, exam_with_year: 'Data 11', exam: 'Data 12',code: 'Data 13', batch: 'Data 14',semester: 'Data 15', examtype: 'Data 16',
    any: 'Data 17', month: 'Data 18',year: 'Data 19', Type: 'Data 20'},
    { id: 3, exam_with_year: 'Data 21', exam: 'Data 22',code: 'Data 23', batch: 'Data 24',semester: 'Data 25', examtype: 'Data 26',
    any: 'Data 27', month: 'Data 28',year: 'Data 29', Type: 'Data 30'}
  ];

  export default data;